import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeBlock() {
  return <section className="py-20 md:py-28 px-6 bg-surface text-center border-t border-white/5" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <FadeIn data-id="element-78">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-amber/10 mb-8" data-id="element-79">
            <ShieldCheck className="w-12 h-12 text-amber" data-id="element-80" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-81">
            60-Day "More Tail Wags" Guarantee
          </h2>

          <p className="text-xl text-body leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-82">
            Try the Canine BioClock Protocol risk-free. If you don't see a
            visible increase in your dog's energy, vitality, and overall health
            within 60 days, email us for a full refund.
          </p>
          <p className="text-lg text-muted italic" data-id="element-83">
            And you keep the protocol and all bonuses as our gift to your dog.
          </p>
        </FadeIn>
      </div>
    </section>;
}